export const TOGGLE_MARKETDETECTOR = "TOGGLE_MARKETDETECTOR";
export const CHANGE_MARKETDETECTOR = "CHANGE_MARKETDETECTOR";

export const toggleMarketDetector = () => ({
  type: TOGGLE_MARKETDETECTOR
});
export function changeMarketDetector(val) {
  return { type: CHANGE_MARKETDETECTOR, val };
}